// src/pages/Kine/kineTourConfig.js

import i18n from "../../../i18n/config";

export const kineTourSteps = [
	{
		popover: {
			title: i18n.t("tours.kine.welcome"),
			description: i18n.t("tours.kine.welcomeDesc"),
			side: "over",
		},
	},
	{
		element: 'input[placeholder*="Search"]',
		popover: {
			title: i18n.t("tours.kine.search"),
			description: i18n.t("tours.kine.searchDesc"),
			position: "bottom",
		},
	},
	{
		element: ".kine-list-scroll",
		popover: {
			title: i18n.t("tours.kine.list"),
			description: i18n.t("tours.kine.listDesc"),
			position: "top",
		},
	},
	{
		element: ".phc-row",
		popover: {
			title: i18n.t("tours.kine.card"),
			description: i18n.t("tours.kine.cardDesc"),
			position: "left",
		},
	},
	{
		popover: {
			title: i18n.t("tours.kine.done"),
			description: i18n.t("tours.kine.doneDesc"),
			side: "over",
		},
	},
];
